<template>
  <CosFullLayout>
    <template #header>
      <div class="tabs-box">
        <a-tabs v-model:activeKey="activeKey" @change="handleChange">
          <a-tab-pane
            key="cos_zbu_fbu"
            tab="谷仓市场营销"
            v-if="fromPermissionToResult('base_applyservice_zbu_fbu_btn')"
          >
          </a-tab-pane>
          <a-tab-pane
            key="cos_zbu_lbu"
            tab="云途市场营销"
            v-if="fromPermissionToResult('base_applyservice_zbu_lbu_btn')"
          >
          </a-tab-pane>
          <a-tab-pane
            key="cos_fbu"
            :tab="t('system.jrmjeh')"
            force-render
            v-if="fromPermissionToResult('base_applyservice_fbu_btn')"
          ></a-tab-pane>
          <a-tab-pane
            key="cos_ofbu"
            :tab="t('system.enzdgq')"
            force-render
            v-if="fromPermissionToResult('base_applyservice_ofbu_btn')"
          ></a-tab-pane>
          <a-tab-pane
            key="cos_lbu"
            :tab="t('system.j7x6fb')"
            v-if="fromPermissionToResult('base_applyservice_lbu_btn')"
          ></a-tab-pane>
        </a-tabs>
      </div>
    </template>
    <template #aside>
      <div class="tree-box">
        <Tree
          :tree-data="treeData"
          @selectTreeData="selectTreeData"
          @emptyTreeData="emptyTreeData"
          @addNewService="addNewService"
          @successRefresh="successRefresh"
          @showEditEmit="showEditEmit"
        ></Tree>
      </div>
    </template>
    <template #main>
      <MenuDetail
        :data="selectTreeDataId"
        :addData="addData"
        :showEdit="showEdit"
        @successRefresh="successRefresh"
      ></MenuDetail>
    </template>
  </CosFullLayout>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue'
import CosFullLayout from '@/components/CosFullLayout/index.vue'
import Tree from './components/Tree.vue'
import MenuDetail from './components/MenuDetail.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { useI18n } from 'vue-i18n'
import type { SystemSetting } from '@/types/systemSetting'
import { baseAll } from '@/api/systemSetting/index'
import { TreeDetail } from './hooks/enum'
import { usePermissionStore } from '@/stores/permission'

const { t } = useI18n()
const activeKey = ref<string>('cos_zbu_fbu')
const subdomain = ref<string>('')
const treeData = ref<SystemSetting.TreeData[]>([])
const treeDataPut = (data: SystemSetting.TreeData[]) => {
  data.forEach((item: SystemSetting.TreeData) => {
    // 在树结构最外层添加key值。为了expend可获取到对应值，实现展开背景色改色
    item.key = item.id
    if (item.children && item.children.length > 0) {
      treeDataPut(item.children)
    }
  })
}
const getBaseAll = async () => {
  try {
    let key: string = activeKey.value
    if (key.startsWith('cos_zbu_')) {
      if (key === 'cos_zbu_fbu') {
        subdomain.value = 'cos_fbu'
      } else if (key === 'cos_zbu_lbu') {
        subdomain.value = 'cos_lbu'
      }
      key = 'cos_zbu'
    } else {
      subdomain.value = ''
    }
    const res: any = await baseAll(
      {
        appId: key
      },
      {
        subdomain: subdomain.value
      }
    )
    treeData.value = res.data
    treeDataPut(treeData.value)
  } catch (error) {
    console.log('getBaseAll-error: ', error)
  }
}
const selectTreeDataId = ref<number>()
const selectTreeData = (node: number) => {
  selectTreeDataId.value = node
}
const emptyTreeData = () => {
  selectTreeDataId.value = TreeDetail.EMPTY
}
const handleChange = () => {
  getBaseAll()
}
const successRefresh = () => {
  getBaseAll()
}
const permissionStore = usePermissionStore()
const permissionBtn = ref()
permissionBtn.value = permissionStore.permission
const fromPermissionToResult = (value: string) => {
  const result = permissionBtn.value.includes(value)
  return result
}
const getData = () => {
  if (fromPermissionToResult('base_applyservice_zbu_fbu_btn')) {
    activeKey.value = 'cos_zbu_fbu'
  } else if (fromPermissionToResult('base_applyservice_zbu_lbu_btn')) {
    activeKey.value = 'cos_zbu_lbu'
  } else if (fromPermissionToResult('base_applyservice_fbu_btn')) {
    activeKey.value = 'cos_fbu'
  } else if (fromPermissionToResult('base_applyservice_ofbu_btn')) {
    activeKey.value = 'cos_ofbu'
  } else if (fromPermissionToResult('base_applyservice_lbu_btn')) {
    activeKey.value = 'cos_lbu'
  } else {
    activeKey.value = ''
    DcMessage.error('暂无权限！')
    return
  }
  getBaseAll()
}
const addData = ref()
const addNewService = (parentData: SystemSetting.AddDataType) => {
  selectTreeDataId.value = TreeDetail.ADDNEW
  addData.value = {
    ...parentData.data,
    appId: activeKey.value.startsWith('cos_zbu_') ? 'cos_zbu' : activeKey.value,
    subdomain: subdomain.value
  }
}
const showEdit = ref<any>(false)
const showEditEmit = (value: Boolean) => {
  showEdit.value = value
}
onMounted(() => {
  // getBaseAll()
  getData()
})
</script>
<style lang="scss" scoped>
#app {
  background-color: rgb(249, 249, 255);
}
.tree-box {
  padding: 16px;
  height: 74vh;
  overflow-y: scroll;
}
:deep(.dc-container main) {
  position: relative;
}
:deep(.dc-layout-main) {
  margin-top: -20px;
}
.tabs-box {
  background-color: rgb(249, 249, 255);
}
:deep(.ant-tabs-nav) {
  background-color: #fff;
  padding-left: 16px;
}
.wrapper-top {
  padding: 0 30px;
  background-color: rgb(249, 249, 255);
}
:deep(.dc-container aside) {
  margin-right: 8px !important;
}
:deep(.ant-tabs-top > .ant-tabs-nav) {
  margin-bottom: 8px !important;
}
:deep(.ant-tabs-top > .ant-tabs-nav:before, .ant-tabs-top > div > .ant-tabs-nav:before) {
  display: none;
}
</style>
